import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { SnackBarTime } from 'app/projects/core/src/lib/constants/snack-bar';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { MaxBrainConfirmDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/confirm/confirm.component';
import { ChangeEmailAddressFailure } from 'app/projects/user/src/lib/actions/change-email-address-failure.action';
import { ChangeEmailAddressSuccess } from 'app/projects/user/src/lib/actions/change-email-address-success.action';
import { ChangeEmailAddress } from 'app/projects/user/src/lib/actions/change-email-address.action';
import { User } from 'app/projects/user/src/lib/models/user';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-change-user-email-address-dialog',
    templateUrl: './change-user-email-address-dialog.component.html',
    styleUrls: ['./change-user-email-address-dialog.component.scss'],
})
export class ChangeUserEmailAddressDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    user: User;

    confirmDialogRef: MatDialogRef<MaxBrainConfirmDialogComponent>;
    loading = false;

    get email() {
        return this.formGroup.get('email');
    }

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(
        private _matDialog: MatDialog,
        private _translateService: TranslateService,
        protected _store: Store,
        private _action$: Actions,
        private _formBuilder: FormBuilder,
        private _matSnackBar: MatSnackBar,
        public dialogRef: MatDialogRef<ChangeUserEmailAddressDialogComponent>
    ) {
        super();
    }

    ngOnInit() {
        this._formGroup = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    async onChangeUserEmailAddress() {
        this.loading = true;

        this._store.dispatch(new ChangeEmailAddress({ id: this.user.id, email: this.email.value }));

        this._action$.pipe(ofActionDispatched(ChangeEmailAddressSuccess), take(1)).subscribe(() => {
            const successMessage = this._translateService.instant('PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.MESSAGE.SAVED');

            this._matSnackBar.open(successMessage, 'OK', {
                verticalPosition: 'top',
                duration: SnackBarTime.medium,
            });

            this.dialogRef.close(true);
        });

        this._action$.pipe(ofActionDispatched(ChangeEmailAddressFailure), take(1)).subscribe((action) => {
            if (action.payload.response.error.message === 'email_change_failed') {
                this.confirmDialogRef = this._matDialog.open(MaxBrainConfirmDialogComponent, {
                    disableClose: false,
                    width: '400px',
                });

                this.confirmDialogRef.componentInstance.confirmTitle = 'ERROR.RESPONSE.error';
                this.confirmDialogRef.componentInstance.confirmMessage = this._translateService.instant('PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.MESSAGE.FAILED', this.user);
                this.confirmDialogRef.componentInstance.hideActionButton = true;
            } else {
                const errorMessage = this._translateService.instant('PAGE.DIALOG.CHANGE_USER_EMAIL_ADDRESS.MESSAGE.USER_EXIST');

                this._matSnackBar.open(errorMessage, 'OK', {
                    verticalPosition: 'top',
                    duration: SnackBarTime.medium,
                });
            }

            this.dialogRef.close(true);
        });
    }
}
